import { render, staticRenderFns } from "./PageProductCharts.vue?vue&type=template&id=dc3af694"
import script from "./PageProductCharts.vue?vue&type=script&lang=js"
export * from "./PageProductCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports